import { createSlice } from "@reduxjs/toolkit";
import {
  deleteHotelRoom,
  deleteUndoHotelRoom,
  fetchHotelProfile,
  fetchRoom,
  updateHotelProfileOnOff,
} from "./hotelThunks";

const initialState = {
  data: [],
  hotel: [],
  totalPages: 1,
  totalItems: 0,
  loading: false,
  hotelLoading: false,
  error: null,
};

const hotelSlice = createSlice({
  name: "hotel",
  initialState,

  extraReducers: (builder) => {
    builder
      // get All Hotel  Status wise
      .addCase(fetchHotelProfile.pending, (state) => {
        state.hotelLoading = true;
      })
      .addCase(fetchHotelProfile.fulfilled, (state, action) => {
        state.hotelLoading = false;
        state.hotel = action.payload.data;
        state.totalPages = action.payload.totalPages;
        state.totalItems = action.payload.totalItems;
      })
      .addCase(fetchHotelProfile.rejected, (state, action) => {
        state.hotelLoading = false;
        state.error = action.payload;
      }) // get All Hotel Room
      .addCase(fetchRoom.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchRoom.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data;
        state.totalPages = action.payload.totalPages;
        state.totalItems = action.payload.totalItems;
      })
      .addCase(fetchRoom.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      }) // Delete Hotel Room
      .addCase(deleteHotelRoom.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteHotelRoom.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.data.findIndex(
          (item) => item._id === action.payload
        );
        if (index !== -1) {
          state.data[index].status = "deleted";
        }
      })
      .addCase(deleteHotelRoom.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Undo Delete Hotel Room
      .addCase(deleteUndoHotelRoom.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteUndoHotelRoom.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.data.findIndex(
          (item) => item._id === action.payload
        );
        if (index !== -1) {
          state.data[index].status = "activate";
        }
      })
      .addCase(deleteUndoHotelRoom.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Update Hotel Booking On/Off Status
      .addCase(updateHotelProfileOnOff.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateHotelProfileOnOff.fulfilled, (state, action) => {
        state.loading = false;
        const { itemId, bookingOnOff } = action.payload;
        const hotelIndex = state.hotel.findIndex(
          (hotel) => hotel._id === itemId
        );
        if (hotelIndex !== -1) {
          state.hotel[hotelIndex].bookingOnOff = bookingOnOff;
        }
      })
      .addCase(updateHotelProfileOnOff.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default hotelSlice.reducer;
